import React from 'react';
import styles from './favorite-notes/FavoriteNotesView.module.css';
import { HeartIcon } from '../../components/Icons';
import api from '../../services/api';

const FavoriteNotesView = ({
  groups,
  expandedState,
  onToggleGroup,
  onDeleteNote,
  renderWithBold,
  loading,
  error,
  emptyCard,
  onStartNoteStudy,
}) => {
  if (!groups.length) {
    return emptyCard;
  }

  return (
    <>
      {loading && <div className={styles.metadataHint}>章节信息加载中...</div>}
      {error && <div className={styles.metadataError}>{error}</div>}
      <div className={styles.groupedWords}>
        {groups.map((bookGroup) => (
          <div key={bookGroup.key} className={styles.bookGroup}>
            <div className={styles.groupHeader}>
              <button
                type="button"
                className={styles.groupToggle}
                onClick={() => onToggleGroup(bookGroup.key)}
                aria-expanded={!!expandedState[bookGroup.key]}
              >
                <span className={styles.caret} aria-hidden="true">
                  {expandedState[bookGroup.key] ? '▾' : '▸'}
                </span>
                <span className={styles.bookGroupTitle}>{bookGroup.bookTitle}</span>
              </button>
              <span className={styles.groupCount}>笔记 {bookGroup.itemCount}</span>
              <button
                type="button"
                className={styles.studyBtn}
                onClick={() => onStartNoteStudy?.(bookGroup)}
              >
                去学习
              </button>
            </div>
            {expandedState[bookGroup.key] && (
              <div className={styles.bookItemsList}>
                {bookGroup.items.map((note) => (
                  <NoteItem
                    key={note.id}
                    note={note}
                    onDeleteNote={onDeleteNote}
                    renderWithBold={renderWithBold}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

const NoteItem = ({ note, onDeleteNote, renderWithBold }) => {
  const [expanded, setExpanded] = React.useState(false);
  const [sentenceData, setSentenceData] = React.useState(null);
  const [loadingSentence, setLoadingSentence] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [aiNoteContent, setAiNoteContent] = React.useState('');
  const [aiNotePhrases, setAiNotePhrases] = React.useState([]);

  const handleToggle = async () => {
    if (!note.chapter_id || note.sentence_id == null) {
      setExpanded((prev) => !prev);
      return;
    }

    if (!expanded && sentenceData == null) {
      fetchSentence();
    }
    setExpanded((prev) => !prev);
  };

  const fetchSentence = async () => {
    setLoadingSentence(true);
    setError(null);
    try {
      const response = await api.get(`/chapters/${note.chapter_id}/sentences/${note.sentence_id}`);
      const payload = response.data || {};
      setSentenceData({
        content_zh: payload.content_zh || payload.zh || payload.contentZh || payload.text || '',
        content_en: payload.content_en || payload.en || payload.contentEn || payload.translation || '',
      });
    } catch (error) {
      console.error('加载原文句子失败', error);
      setError('加载原文句子失败');
    } finally {
      setLoadingSentence(false);
    }
  };

  React.useEffect(() => {
    if (String(note.note_content ?? '').trim() === '-1') {
      fetchAiNoteContent();
    }
  }, [note.note_content]);

  const fetchAiNoteContent = async () => {
    if (!note.chapter_id || note.sentence_id == null) {
      return;
    }
    try {
      const response = await api.get(`/chapters/${note.chapter_id}`);
      const chapter = response.data || {};
      let aiNotes = [];
      try {
        if (typeof chapter.ai_notes === 'string') {
          aiNotes = JSON.parse(chapter.ai_notes);
        } else if (Array.isArray(chapter.ai_notes)) {
          aiNotes = chapter.ai_notes;
        }
      } catch (error) {
        console.error('解析 ai_notes 失败', error);
      }

      const target = aiNotes.find((item) => Number(item?.sentence_id ?? item?.sentenceId) === Number(note.sentence_id));
      if (!target) {
        setAiNoteContent('AI 笔记');
        setAiNotePhrases([]);
        return;
      }

      const phrases = Array.isArray(target.key_phrases)
        ? target.key_phrases
        : Array.isArray(target.keyPhrases)
          ? target.keyPhrases
          : [];
      setAiNotePhrases(phrases);

      const text = phrases
        .map((phrase) => {
          if (!phrase || typeof phrase !== 'object') {
            return '';
          }
          const lines = [];
          const title = [phrase.phrase || '', phrase.meaning || '']
            .filter(Boolean)
            .join('：')
            .trim();
          if (title) {
            lines.push(title);
          }
          if (phrase.usage_note) {
            lines.push(`用法：${phrase.usage_note}`);
          }
          if (phrase.example_en) {
            lines.push(`例句：${phrase.example_en}`);
          }
          if (phrase.example_cn) {
            lines.push(phrase.example_cn);
          }
          return lines.join('\n');
        })
        .filter(Boolean)
        .join('\n\n');
      setAiNoteContent(text || 'AI 笔记');
    } catch (error) {
      console.error('加载 AI 笔记内容失败', error);
      setAiNoteContent('AI 笔记');
      setAiNotePhrases([]);
    }
  };

  return (
    <div className={styles.noteItem}>
      <div className={styles.noteHeader}>
        <div className={styles.noteInfo}>
          {/* <div className={styles.noteTitleRow}>
            <span className={styles.noteChapter}>
              {note.chapter_title || `章节 ${note.chapter_id}`}
            </span>
            {typeof note.sentence_id === 'number' && (
              <span className={styles.noteSentence}> · 句子 {note.sentence_id + 1}</span>
            )}
          </div> */}
         

        </div>
        
        <div className={styles.noteActions}>
          {note.chapter_id && note.sentence_id != null && (
            <button
              type="button"
              className={styles.toggleSentenceBtn}
              onClick={handleToggle}
              aria-expanded={expanded}
            >
              {expanded ? '隐藏原文' : '查看原文'}
            </button>
          )}
          <button
            type="button"
            className={styles.deleteButton}
            onClick={() => onDeleteNote(note.id)}
            title="取消收藏"
            aria-label="取消收藏"
          >
            <HeartIcon size={20} filled />
          </button>
        </div>
      </div>
      {expanded && (
        <div className={styles.sentenceContainer}>
          {loadingSentence ? (
            <div className={styles.sentenceLoading}>原文加载中…</div>
          ) : error ? (
            <div className={styles.sentenceError}>{error}</div>
          ) : sentenceData ? (
            <>
              {sentenceData.content_zh && (
                <div className={styles.sentenceBlock}>
                  {/* <span className={styles.sentenceLabel}>中文</span> */}
                  <p className={styles.sentenceText}>{sentenceData.content_zh}</p>
                </div>
              )}
              {sentenceData.content_en && (
                <div className={styles.sentenceBlock}>
                  {/* <span className={styles.sentenceLabel}>英文</span> */}
                  <p className={styles.sentenceText}>{sentenceData.content_en}</p>
                </div>
              )}
            </>
          ) : (
            <div className={styles.sentenceEmpty}>未找到原文句子</div>
          )}
        </div>
      )}
      {String(note.note_content ?? '').trim() === '-1' ? (
        aiNotePhrases.length > 0 ? (
        <div className={styles.aiNotePhraseList}>
          {aiNotePhrases.map((phrase, idx) => (
            <div key={`ai-note-phrase-${note.id}-${idx}`} className={styles.aiNotePhraseItem}>
              <div className={styles.aiNotePhraseHeader}>
                <span className={styles.aiNotePhraseTitle}>{phrase?.phrase || '短语'}</span>
                {phrase?.meaning && (
                  <span className={styles.aiNotePhraseMeaning}>{phrase.meaning}</span>
                )}
              </div>
              {phrase?.usage_note && (
                <p className={styles.aiNotePhraseUsage}>
                  <strong>用法：</strong>
                  {phrase.usage_note}
                </p>
              )}
              {phrase?.example_en && (
                <p className={styles.aiNotePhraseExample}>
                  <strong>例句：</strong>
                  {phrase.example_en}
                </p>
              )}
              {phrase?.example_cn && (
                <p className={styles.aiNotePhraseExampleCn}>{phrase.example_cn}</p>
              )}
            </div>
          ))}
        </div>
        ) : (
          <div className={styles.noteContent}>{aiNoteContent || 'AI 笔记'}</div>
        )
      ) : (
        <div className={styles.noteContent}>{note.note_content}</div>
      )}
      <div className={styles.noteMeta}>
        {note.created_at ? new Date(note.created_at).toLocaleString() : ''}
      </div>

      
    </div>
  );
};

export default FavoriteNotesView;
